import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SfaSalesLeadContainerModel } from '../../../../../../models/aggregates/sfa/salesLead/SfaSalesLeadContainer.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';

@Injectable({
    providedIn: 'root'
    })
    export class SfaSalesLeadService extends BaseApiTemplateService<SfaSalesLeadContainerModel> {

    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'sales-leads';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'sales-leads';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'sales-leads';
        this.httpClient = http;
    }
    }
